export class ErrorConstants {
    public static get httpError(): string { return 'There was an HTTP error'; }
    public static get typeError(): string { return 'There was a Type error'; }
    public static get generalError(): string { return 'There was a general error.'; }
    public static get unexpectedHappened(): string { return 'Unexpected thing happened.'; }
}
